"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cCommunicationMetaDataSchema = exports.cICommunicationDataReportSchema = void 0;
var zod_1 = require("zod");
var files_1 = require("../files");
exports.cICommunicationDataReportSchema = zod_1.z.object({
    isReported: zod_1.z.optional(zod_1.z.boolean()),
    reportedBy: zod_1.z.optional(zod_1.z.array(zod_1.z.number())),
    adminDelete: zod_1.z.optional(zod_1.z.boolean()),
    adminMessage: zod_1.z.optional(zod_1.z.array(zod_1.z.string()))
});
exports.cCommunicationMetaDataSchema = zod_1.z.object({
    /**
     * When a user schedules a meeting time with another, this contains the
     * time and the accountId of the user who scheduled it.
     */
    suggestedDates: zod_1.z.optional(zod_1.z.array(zod_1.z.strictObject({
        scheduledDate: zod_1.z.string(),
        scheduledTime: zod_1.z.string(),
        agreed: zod_1.z.boolean(),
        suggestedByAccountId: zod_1.z.number()
    }))),
    /** Route name (part of location data) */
    name: zod_1.z.optional(zod_1.z.string()),
    /** Page route reference (part of location data) */
    page: zod_1.z.optional(zod_1.z.string()),
    /** Information about media files or references (e.g. youtube embeds) */
    media: zod_1.z.optional(zod_1.z.array(zod_1.z.object({
        /** Number when the file is local (points to id in files table), string when id of a youtube or vimeo video */
        dataId: zod_1.z.number().or(zod_1.z.string()),
        /** Local when the file was uploaded and stored by us, remote when it points to a URL */
        source: zod_1.z.enum(['local', 'youtube', 'vimeo']),
        /** Should match FileType from aluminate-api/models/Files */
        type: zod_1.z.optional(zod_1.z.enum([
            files_1.FileType.file,
            files_1.FileType.image,
            files_1.FileType.video,
            files_1.FileType.audio,
            files_1.FileType.document
        ])),
        /** more information about a file type */
        mime: zod_1.z.optional(zod_1.z.string()),
        /** If a video has been added from a remote URL, this is where it'll be stored */
        originalURL: zod_1.z.optional(zod_1.z.string())
    }))),
    /** Page slug (part of location data) */
    pageSlug: zod_1.z.optional(zod_1.z.string()),
    /** Module slug (part of location data) */
    moduleSlug: zod_1.z.optional(zod_1.z.string()),
    /** The id of the connection in the userListMap table, if part of a connection */
    connectionUserListMapId: zod_1.z.optional(zod_1.z.number()),
    entityId: zod_1.z.optional(zod_1.z.string().uuid()),
    /** URL leading to the comment */
    linkToComment: zod_1.z.optional(zod_1.z.string()),
    /** Path to the file, if a file communication */
    path: zod_1.z.optional(zod_1.z.string()),
    /** The id of the chat message, if applicable (chats only) */
    messageId: zod_1.z.optional(zod_1.z.number()),
    /** Information about reported messages */
    report: zod_1.z.optional(exports.cICommunicationDataReportSchema),
    applicationMeta: zod_1.z.optional(zod_1.z.array(zod_1.z.object({
        application: zod_1.z.optional(zod_1.z.object({
            id: zod_1.z.string().uuid(),
            requestApplication: zod_1.z.optional(zod_1.z.string().uuid()),
            formData: zod_1.z.any(),
            connectionId: zod_1.z.string().uuid()
        })),
        applicationFields: zod_1.z.optional(zod_1.z.any())
    }))),
    userListId: zod_1.z.optional(zod_1.z.string().uuid()),
    /** Entity power-up connection type id, if applicable */
    connectionId: zod_1.z.optional(zod_1.z.string().uuid()),
    /** Connection leader id, if applicable */
    leaderId: zod_1.z.optional(zod_1.z.number()),
    /** userListMap row id, if applicable (for connections) */
    listMembershipId: zod_1.z.optional(zod_1.z.number()),
    /** Title of the discussion in which the comment was posted */
    title: zod_1.z.optional(zod_1.z.string()),
    data: zod_1.z.optional(zod_1.z.any())
});
